import React from 'react';

interface Props {
    title: string;
    onClose: () => void;
    children: React.ReactNode;
    width?: number;
}

export default function Modal({ title, onClose, children, width = 480 }: Props) {
    return (
        <div style={styles.overlay} onClick={onClose}>
            <div
                style={{ ...styles.modal, width }}
                onClick={e => e.stopPropagation()}
            >
                <div style={styles.header}>
                    <h2 style={styles.title}>{title}</h2>
                    <button style={styles.close} onClick={onClose}>✕</button>
                </div>
                <div style={styles.body}>{children}</div>
            </div>
        </div>
    );
}

const styles: Record<string, React.CSSProperties> = {
    overlay: {
        position: 'fixed', inset: 0,
        background: 'rgba(0,0,0,0.4)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1000,
    },
    modal: {
        background: '#fff', borderRadius: 12,
        boxShadow: '0 24px 64px rgba(0,0,0,0.15)',
        overflow: 'hidden',
        maxHeight: '90vh',
        display: 'flex',
        flexDirection: 'column',
    },
    header: {
        display: 'flex', alignItems: 'center',
        justifyContent: 'space-between',
        padding: '20px 24px',
        borderBottom: '1px solid #eee',
        flexShrink: 0,
    },
    title: { fontSize: 18, fontWeight: 600, margin: 0 },
    close: {
        background: 'none', border: 'none',
        fontSize: 18, cursor: 'pointer', color: '#999',
        padding: '4px 8px',
    },
    body: {
        padding: 24,
        overflowY: 'auto',
        flex: 1,
    },
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface ModalProps {
    title: string;
    onClose: () => void;
    children: React.ReactNode;
    wide?: boolean;
}